import { render, staticRenderFns } from "./ClubReportTable.vue?vue&type=template&id=b1542ede&"
import script from "./ClubReportTable.vue?vue&type=script&lang=js&"
export * from "./ClubReportTable.vue?vue&type=script&lang=js&"
import style0 from "./ClubReportTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports